import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ModalProvider } from 'contexts/modal-context';

export interface IContextProvider {
  children: React.ReactNode;
}

const AppProviders = ({ children }: IContextProvider) => (
  <React.Suspense fallback={<div>loading...</div>}>
    <ModalProvider>
      <Router basename="/megrendelo">{children}</Router>
    </ModalProvider>
  </React.Suspense>
);

export default AppProviders;
